import { render, staticRenderFns } from "./AvaliacoesDespesasGeraisMenu.vue?vue&type=template&id=0f259c5f"
import script from "./AvaliacoesDespesasGeraisMenu.vue?vue&type=script&lang=js"
export * from "./AvaliacoesDespesasGeraisMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports